<script setup>
	import {
		ref,
		computed,
	} from 'vue';
	import { DsButton } from '@coloplast/design-system';
	import initCampaignIdSFDC from 'shared/vanilla/initSendCampaignIDtoSFDC';
	import { useStore } from 'vuex';
	import Events from 'shared/settings/events';

	const store = useStore();

	//we need it if user is not logged in and we show popup first in case we have a button "add sample to basket"
	store.commit('setIsProductCardOnCampaignPage', true);

	const props = defineProps({
		vm: {
			type: Object,
			default: () => { },
		},
		openInNewWindow: {
			type: Boolean,
			default: () => false,
		},
		isInlineLayout: {
			type: Boolean,
			default: () => false,
		},
		variant: {
			type: String,
		}
	});

	const
		addItemToBasketRequest = ref(props?.vm?.BaseViewModel?.AddItemToBasketRequest),
		shouldTrackId = ref(props?.vm?.BaseViewModel?.ShouldTrackSfdcCampaign),
		campaignId = ref(props.vm?.CurrentBlock?.CampaignId || props.vm?.CurrentPage?.CampaignId),
		campaignStatus = ref(props.vm?.CurrentBlock?.CampaignStatus || props.vm?.CurrentPage?.CampaignStatus);

	const
		ctaButtonModel = computed(() => {
			if (props?.vm?.CurrentPage?.CtaButton) {
				return props.vm.CurrentPage.CtaButton;
			}
			else {
				return props?.vm?.CurrentBlock?.CtaButton ? props.vm.CurrentBlock.CtaButton : props.vm.CurrentBlock;
			}
		}),
		isForDownload = computed(() => {
			return ctaButtonModel.value?.IsDownload === 'True';
		}),
		isDownloadedImmediately = computed(() => {
			return ctaButtonModel.value?.StartDownloadImmediately === 'True';
		}),
		ctaButtonVariant = computed(() => {
			if (ctaButtonModel.value?.Variant) {
				return ctaButtonModel.value.Variant;
			} else if (props.vm.BaseViewModel?.CtaButtonVariant) {
				return props.vm.BaseViewModel.CtaButtonVariant;
			} else if (props.variant) {
				return props.variant;
			} else {
				return 'primary';
			}
		});

	async function addSampleAction(variant) {
		if (shouldTrackId.value) {
			initCampaignIdSFDC(campaignId.value, campaignStatus.value)
		}
		const response = await store.dispatch('addItemToBasket', variant);

		if (response.status === 200) {
			const openFlyoutBasket = new CustomEvent(Events.ACTIVATE_FLY_OUT_BASKET, {});
			document.dispatchEvent(openFlyoutBasket);
		}
	}
</script>

<template>
	<DsButton v-if="!addItemToBasketRequest"
			  :variant="ctaButtonVariant"
			  data-testid="cta"
			  :href="vm.BaseViewModel.CtaButtonLinkUrl || ctaButtonModel.CtaButtonLink"
			  :icon-start="ctaButtonModel?.IconStart"
			  :icon-end="ctaButtonModel?.IconEnd"
			  :target="openInNewWindow ? '_blank' : null"
			  :size="isInlineLayout ? 'sm' : 'md'"
			  :download="(isForDownload || isDownloadedImmediately) ? true : null"
			  @click="shouldTrackId && initCampaignIdSFDC(campaignId, campaignStatus)">
		{{ ctaButtonModel.Text || ctaButtonModel.CtaButtonText }}
	</DsButton>
	<DsButton
			  v-else
			  :variant="ctaButtonVariant"
			  :icon-end="ctaButtonModel?.IconEnd || 'shopping-basket'"
			  :size="isInlineLayout ? 'sm' : 'md'"
			  :clickHandler="() => addSampleAction(addItemToBasketRequest)"
			  >
		{{ ctaButtonModel.Text || ctaButtonModel.CtaButtonText }}
	</DsButton>
</template>
